import { useCallback, useEffect, useState } from "react"
import { Platform, View } from "react-native"

import { Dialog as ThemedDialog } from "@rn-vui/themed"

import type { OpenWebsiteDialogState } from "src/utils/openWebsiteDialog"
import { Button, Text } from "src/components/Ignite"
import { useAppTheme } from "src/hooks/useAppTheme"
import { openWebsiteDialogManager, openWebsiteUrlInNewTab } from "src/utils/openWebsiteDialog"

export function OpenWebsiteNewTabDialog() {
  const { theme } = useAppTheme()
  const [state, setState] = useState<OpenWebsiteDialogState>(
    openWebsiteDialogManager.getCurrentState(),
  )

  useEffect(() => openWebsiteDialogManager.subscribe(setState), [])

  const onCancel = useCallback(() => {
    openWebsiteDialogManager.hide()
  }, [])

  const onOpenInNewTab = useCallback(() => {
    if (state.url) {
      openWebsiteUrlInNewTab(state.url)
    }
    openWebsiteDialogManager.hide()
  }, [state.url])

  if (Platform.OS !== "web") return null

  return (
    <ThemedDialog
      isVisible={state.isVisible}
      onBackdropPress={onCancel}
      overlayStyle={{
        backgroundColor: theme.colors.background,
        borderRadius: 12,
        padding: 24,
        maxWidth: 400,
        width: "90%",
      }}
    >
      <Text
        style={{
          color: theme.colors.text,
          fontWeight: "600",
          fontSize: 18,
          marginBottom: 20,
          textAlign: "center",
        }}
      >
        This website must be opened in a new tab.
      </Text>
      <View style={{ flexDirection: "row", gap: 12, flexWrap: "wrap" }}>
        <View style={{ flex: 1, minWidth: 120 }}>
          <Button text="Open in a new tab" preset="reversed" onPress={onOpenInNewTab} />
        </View>
        <View style={{ flex: 1, minWidth: 120 }}>
          <Button text="Cancel" preset="subtle" onPress={onCancel} />
        </View>
      </View>
    </ThemedDialog>
  )
}
